/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
export type RowActionsCell_DisplayFragment = { __typename: 'Display', id: string, alias?: string | null, serialNumber: string, configurationSyncStatus?: Types.ConfigurationSyncStatus | null, configuration?: { __typename: 'ConfigurationModel', id: string } | null };

export const RowActionsCell_DisplayFragmentDoc = gql`
    fragment RowActionsCell_display on Display {
  id
  alias
  serialNumber
  configuration {
    id
  }
  configurationSyncStatus
}
    `;